import { CustomerSubscriptionModel } from '.';

export class CustomerSignatureModel {
  constructor(data={}) {
    this._id = data?._id || null;

    this.type = data.type || null;
    this.subscription = new CustomerSubscriptionModel(data.subscription || {});
    
    this.token = data.token || null;
    this.expiredAt = data.expiredAt || null;
  }
}
